// Stats / ROI band
const Stats = () => {
  const stats = [
    { prefix: "+ ", value: 21, decimals: 0, suffix: " %", l: "Ökad genomsnittlig vinst per projekt." },
    { prefix: "", value: 11, decimals: 0, suffix: " ×", l: "Fler offerter skickade per vecka." },
    { prefix: "− ", value: 12, decimals: 0, suffix: " tim", l: "Administration per vecka." },
    { prefix: "", value: 23, decimals: 0, suffix: " min", l: "Genomsnittlig svarstid på nya affärer." },
  ];

  const sectionRef = React.useRef(null);
  const [started, setStarted] = React.useState(false);

  React.useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setStarted(true);
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            setStarted(true);
            io.disconnect();
            break;
          }
        }
      },
      { threshold: 0.3 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section className="section stats-section" ref={sectionRef}>
      <div className="container">
        <div className="section-head">
          <h2 style={{ maxWidth: 680 }}>Mindre tid på papper, mer tid på platsen.</h2>
        </div>
        <div className="stats-grid">
          {stats.map((s, i) => (
            <div key={i} className="stat-cell">
              <div className="stat-v">
                <CountUp value={s.value} decimals={s.decimals} prefix={s.prefix} suffix={s.suffix} start={started} delay={i * 110} />
              </div>
              <div className="stat-l">{s.l}</div>
            </div>
          ))}
        </div>
        <div className="stats-note mono">Källa: Byggro användarstudie Jan 2026</div>
      </div>
    </section>
  );
};

const CountUp = ({ value, decimals = 0, prefix = "", suffix = "", start, delay = 0, duration = 1200 }) => {
  const [n, setN] = React.useState(start ? value : 0);

  React.useEffect(() => {
    if (!start) return;
    let raf;
    const begin = performance.now() + delay;
    const tick = (now) => {
      const t = now - begin;
      if (t <= 0) {
        setN(0);
        raf = requestAnimationFrame(tick);
        return;
      }
      if (t >= duration) {
        setN(value);
        return;
      }
      const p = t / duration;
      const eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
      setN(value * eased);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [start, value, delay, duration]);

  return (
    <>
      {prefix}
      {n.toFixed(decimals)}
      {suffix}
    </>
  );
};

Object.assign(window, { Stats });
